import { PlusCircleMultipleIcon } from './PlusCircleMultipleIcon';

/**
 * author: Michael Irigoyen
 * id 93BBA1EA-76F8-4D2E-B4D0-98F684B15AC3
 * name plus-circle-multiple
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-circle-multiple.svg
 * tags
 */
export const CoinsPlusIcon = PlusCircleMultipleIcon;
export default CoinsPlusIcon